import { ValidationError } from '../../shared/errors/BaseErrors';
import { ChannelType } from '../../shared/types/Channel';
import { SendingTime } from '../value-objects/SendingTime';

export const MIN_CHANNEL_SENDING_INTERVAL_MINUTES = 1;
export const MAX_CHANNEL_SENDING_INTERVAL_MINUTES = 720 * 60;

const CHANNEL_TYPES: ChannelType[] = [ChannelType.FREE, ChannelType.PAID, ChannelType.DEACTIVATED];

export const ChannelAdministrationRules = {
  ensureType(type: ChannelType): ChannelType {
    if (!CHANNEL_TYPES.includes(type)) throw new ValidationError('channel-type-unknown');
    return type;
  },
  ensureSendingInterval(minutes: number): number {
    if (!Number.isInteger(minutes) || minutes < MIN_CHANNEL_SENDING_INTERVAL_MINUTES || minutes > MAX_CHANNEL_SENDING_INTERVAL_MINUTES) {
      throw new ValidationError('channel-minimal-sending-interval-out-of-range');
    }
    return minutes;
  },
  ensureSendingTime(time: string): string {
    if (!SendingTime.isValid(time)) throw new ValidationError('channel-sending-window-invalid');
    return time;
  },
  ensureSendingWindow(start: string, end: string): { start: string; end: string } {
    if (!SendingTime.isValid(start) || !SendingTime.isValid(end) || !SendingTime.isBefore(start, end)) {
      throw new ValidationError('channel-sending-window-invalid');
    }
    return { start, end };
  },
  ensureMembersCount(count: number): number {
    if (!Number.isInteger(count) || count < 0) throw new ValidationError('channel-members-count-negative');
    return count;
  },
  ensureCategoryName(name: string): string {
    const trimmed = (name ?? '').trim();
    if (!/[\p{L}\p{N}]/u.test(trimmed)) throw new ValidationError('channel-category-name-invalid');
    return trimmed;
  },
};
